import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ProcurementSupplierEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(439)); 
console.log(permission);

    axios
      .get(`/procurementsupplier/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        //setBackendErrors(response.data.data.supplier);
        setValue(response.data.data.supplier);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      name: value.name,
      address: value.address,
      supplier_type: value.supplier_type,
      contact_person: value.contact_person,
      phone_number: value.phone_number,
      bank_number: value.bank_number,
      bank_name: value.bank_name,
      if: value.if,
      ice: value.ice,
      note: value.note,
    },
    enableReinitialize: true,
    onSubmit: (values,{ setSubmitting })=> {
      axios
        .post("/procurementsupplier/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
         
          $("#form-submit").text("Update Supplier");
          if (response.data.code === 200) {
            toast.success(response.data.message);
           
            setTimeout(() => {
              window.location.href = "/procurementsuppliers";
            }, 1000);
          }  else if (response.data.code === 422) {
            setSubmitting(false);
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
          else {
            setSubmitting(false);
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error)
          setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    axios
      .get("/helpers/trader-farmer-supplier-types", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let supplier_types = response.data.data.types;
          // setPackagingTypesLists(materials_payment_status);
          let supplier_typesList = supplier_types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `supplier-${index}`,
          }));
          setStatusOptions(supplier_typesList);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Procurement Suppliers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/procurementsuppliers">Procurement Suppliers</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Supllier </h4>
                    {permission && permission.update === 1 && (
                     <FormikProvider value={formik}>
                     <form action="#" onSubmit={formik.handleSubmit}>
                     <div className="row">
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Name</label>
                           <input
                             type="text"
                             name="name"
                             value={formik.values.name}
                             className={
                               backendErrors.name
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                           
                             onChange={(e) => {
                               formik.handleChange(e);
                               customHandleInput(e);
                             }}
                              onBlur={formik.handleBlur}
                           />
                          <small>
                             {backendErrors.name  && (
                               <span className="form-error mt-1">
                                 {backendErrors.name}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-6">
                         <div className="form-group status">
                           <label>Supplier Type</label>
                           {statusOptions.length > 0 && (
                                 <Select
                                 className="w-100"
                                 value={statusOptions.find(option => option.value == formik.values.supplier_type) || null} // Ensure correct format
                                 name="supplier_type"
                                 onChange={(selectedOption) => {
                                 handleSelectChange("supplier_type", selectedOption);
                               //   generateLotNumberLocation(selectedOption.value);
                                 }}
                                 onBlur={formik.handleBlur}
                                 options={statusOptions}
                                 placeholder="Select"

                                 // className={
                                 //   backendErrors.supplier_type
                                 //     ? "w-100 input-error"
                                 //     : "w-100"
                                 // }
                                 // data={statusOptions}
                                 // value={formik.values.supplier_type}
                                 // name="supplier_type"

                                 // onChange={(e) => {
                                 //   formik.handleChange(e);
                                 //   customHandleInput(e);
                                 // }}
                                 //   onBlur={formik.handleBlur}
                                 // options={{
                                 //   placeholder: "Select Supplier",
                                 // }}
                                 />
                           )}
                          
                         <small>
                             {backendErrors.supplier_type  && (
                               <span className="form-error mt-1">
                                 {backendErrors.supplier_type}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-12">
                         <div className="form-group">
                           <label>Address</label>
                           <input
                             type="text"
                             name="address"
                             value={formik.values.address}
                             className={
                               backendErrors.address
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                           
                             onChange={(e) => {
                               formik.handleChange(e);
                               customHandleInput(e);
                             }}
                              onBlur={formik.handleBlur}
                           />
                             <small>
                             {backendErrors.address  && (
                               <span className="form-error mt-1">
                                 {backendErrors.address}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Phone Number</label>
                           <input
                             type="text"
                             name="phone_number"
                             value={formik.values.phone_number}
                             className={
                               backendErrors.phone_number
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                            
                             onChange={(e) => {
                               formik.handleChange(e);
                               customHandleInput(e);
                             }}
                             onBlur={formik.handleBlur}
                           />
                            <small>
                             {backendErrors.phone_number  && (
                               <span className="form-error mt-1">
                                 {backendErrors.phone_number}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Contact Person</label>
                           <input
                             type="text"
                             name="contact_person"
                             value={formik.values.contact_person}
                             className={
                               backendErrors.contact_person
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                            
                             onChange={(e) => {
                               formik.handleChange(e);
                               customHandleInput(e);
                             }}
                             onBlur={formik.handleBlur}
                           />
                            <small>
                             {backendErrors.contact_person  && (
                               <span className="form-error mt-1">
                                 {backendErrors.contact_person}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Bank Number</label>
                           <input
                             type="text"
                             onKeyPress={(event) => {
                               // Allow only numbers (0-9)
                               if (!/^[0-9]$/.test(event.key)) {
                               event.preventDefault();
                               }
                             }}
                             name="bank_number"
                             value={formik.values.bank_number}
                             className={
                               backendErrors.bank_number
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.bank_number && (
                               <span className="form-error mt-1">
                                 {backendErrors.bank_number}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>

                       <div className="col-md-6">
                         <div className="form-group">
                           <label>Bank Name</label>
                           <input
                             type="text"
                             name="bank_name"
                             value={formik.values.bank_name}
                             className={
                               backendErrors.bank_name
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.bank_name && (
                               <span className="form-error mt-1">
                                 {backendErrors.bank_name}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
 
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>IF</label>
                           <input
                             type="text"
                             name="if"
                             value={formik.values.if}
                             className={
                               backendErrors.if
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.if && (
                               <span className="form-error mt-1">
                                 {backendErrors.if}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       
                       <div className="col-md-6">
                         <div className="form-group">
                           <label>ICE</label>
                           <input
                             type="text"
                             name="ice"
                             value={formik.values.ice}
                             className={
                               backendErrors.ice
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={formik.handleChange}
                             onBlur={formik.handleBlur}
                           />
                         <small>
                             {backendErrors.ice && (
                               <span className="form-error mt-1">
                                 {backendErrors.ice}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>

                       <div className="col-md-12">
                         <div className="form-group">
                           <label>Note</label>
                           <textarea
                             name="note"
                             value={formik.values.note}
                             className={
                               backendErrors.note
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                            
                             onChange={(e) => {
                               formik.handleChange(e);
                               customHandleInput(e);
                             }}
                             onBlur={formik.handleBlur}
                           />
                           <small>
                             {backendErrors.note  && (
                               <span className="form-error mt-1">
                                 {backendErrors.note}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                     </div>
                     <small>
                         {backendErrors.status  && (
                           <span className="form-error mt-1">
                             {backendErrors.status}
                           </span>
                         )}

                       </small>
                     <div className="text-end mt-4">
                       <button
                         type="submit" id="form-submit"
                         className="btn btn-primary"
                         disabled={formik.isSubmitting}
                       >
                         Update Supplier
                       </button>
                     </div>
                   </form>
                     </FormikProvider>
                  
                    )}
                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProcurementSupplierEdit;
